import React from "react";
import { useHistory } from "react-router-dom";

// Services
import UserService from "../../services/UserService";

// Components
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";

const DeleteDialog = ({ item, handleClose }) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      console.log("sdfghjkl;lkjhgf");
      await UserService.delete(item.id);
      history.push("/users");
      toast.success(`L'utilisateur ${item.email} a été supprimé avec succès`);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
    >
      <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Voulez-vous vraiment supprimer l'utilisateur : <strong>{item.email}</strong> ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annuler</Button>
        <Button onClick={()=>handleDelete()} disabled={isLoading} color="error" autoFocus>
          {isLoading ? <CircularProgress sx={{ color: "white" }} /> : "Supprimer"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
